import "./src/styles/global.css"
import { startZohoConsentTracking } from "./src/components/zohoConsentTracker"

export const onClientEntry = () => {
  startZohoConsentTracking()
}

// import React from "react"
// import CookieBanner from "./src/components/cookieBanner"

// export const wrapPageElement = ({ element }) => (
//   <>
//     {element}
//     <CookieBanner />
//   </>
// )